import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useModalContext } from '@starbucks-web/pattern-library/lib/components/modal-provider';

import {
  modalToOpenByHashSelector,
  modalToBeClosedSelector,
} from 'shared/app/shell/state/selectors/app-ui';
import {
  clearClosedModalHash,
  setModalByHashClosed,
} from 'shared/app/shell/state/action-creators/app-lifecycle';

const useModalsOpenedByUrlHash = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const modalToOpenByHash = useSelector(modalToOpenByHashSelector);
  const modalToBeClosed = useSelector(modalToBeClosedSelector);

  const { closeModal, openModal } = useModalContext();

  useEffect(() => {
    // Closing any open modal before opening a new one
    // will help preserve return focus management.
    if (modalToBeClosed) {
      // If we're responding to a url hash change, we need to
      // close the modal. If the modal was already set closed
      // (ie. by clicking the close button) calling
      // closeModal with the id (hash) here won't do anything, but
      // it is harmless to do so.
      closeModal(modalToBeClosed.hash);
      dispatch(clearClosedModalHash(modalToBeClosed.hash));
    }
    if (modalToOpenByHash) {
      openModal({
        ariaLabel: formatMessage(modalToOpenByHash.ariaLabelMessage),
        component: modalToOpenByHash.component,
        id: modalToOpenByHash.hash,
        onClose: () => {
          dispatch(setModalByHashClosed(modalToOpenByHash.hash));
        },
      });
    }
  }, [modalToOpenByHash, modalToBeClosed]);
};

export default useModalsOpenedByUrlHash;
